// /andrea_test — chroma-green test surface for the NewsTicker.
//
// Solid chroma-key green background (#00B140 — the standard
// greenscreen shade most virtual-set / keying pipelines expect)
// fills the entire viewport edge-to-edge. The NewsTicker sits
// vertically centred against it. No Header, no Footer, no other
// site chrome — totally flat for clean capture.

import NewsTicker from './NewsTicker';

export default function AndreaTestPage() {
  return (
    <div
      style={{
        background: '#00B140',
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'stretch',
      }}
    >
      <div style={{ width: '100%' }}>
        <NewsTicker />
      </div>
    </div>
  );
}
